// Authoritative nav — ported verbatim from the frozen mockup (v0.7) `NAV` + `canSee`.
// Route ids match the mockup so the sidebar, router, and labels stay 1-to-1.
export const NAV = {
  work: [
    { id: 'today', ic: 'today', label: 'My Day' },
    { id: 'leads', ic: 'leads', label: 'Leads & Pipeline' },
    { id: 'visits', ic: 'visits', label: 'Customer Visits' },
    { id: 'requests', ic: 'requests', label: 'Requests' },
    { id: 'map', ic: 'map', label: 'Territory Map' },
    { id: 'score', ic: 'score', label: 'Scoreboard' },
  ],
  admin: [
    { id: 'tenants', ic: 'store', label: 'Tenants' },
    { id: 'users', ic: 'users', label: 'User Management' },
    { id: 'stores', ic: 'store', label: 'Stores / Hubs' },
    { id: 'terr', ic: 'terr', label: 'Territory Settings' },
    { id: 'import', ic: 'importf', label: 'CSV Import' },
    { id: 'journey', ic: 'audit', label: 'Sales Journey' },
    { id: 'settings', ic: 'settings', label: 'Settings' },
  ],
  oversight: [{ id: 'audit', ic: 'audit', label: 'Audit Log' }],
};

// Owner/HQ-only admin views. 'journey' is the owner-only Sales Journey export
// (CRM revisions Task 5) — managers and agents must not see or export it.
const ADMIN_ONLY = ['users', 'stores', 'terr', 'import', 'journey', 'settings'];
// HQ-Admin-only platform views (creating/switching tenants).
const HQ_ONLY = ['tenants'];

// Role-gated visibility (mirrors mockup `canSee`). Mirrored server-side by firestore.rules.
export function canSee(view, role) {
  if (HQ_ONLY.includes(view)) return role === 'hqadmin';
  if (ADMIN_ONLY.includes(view)) return role === 'hqadmin' || role === 'owner';
  if (view === 'audit') return role !== 'agent';
  return true;
}

export const DEFAULT_VIEW = 'today';
